"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyBankPaymentsSettingType = exports.CompanyBankPaymentsSettingsMode = void 0;
var CompanyBankPaymentsSettingsMode;
(function (CompanyBankPaymentsSettingsMode) {
    CompanyBankPaymentsSettingsMode["FORCE"] = "FORCE";
    CompanyBankPaymentsSettingsMode["SUGGEST"] = "SUGGEST";
})(CompanyBankPaymentsSettingsMode = exports.CompanyBankPaymentsSettingsMode || (exports.CompanyBankPaymentsSettingsMode = {}));
var CompanyBankPaymentsSettingType;
(function (CompanyBankPaymentsSettingType) {
    CompanyBankPaymentsSettingType["BANK_PROVIDER_SETTINGS"] = "BANK_PROVIDER_SETTINGS";
    CompanyBankPaymentsSettingType["TRANSACTION_VALUE_SETTINGS"] = "TRANSACTION_VALUE_SETTINGS";
})(CompanyBankPaymentsSettingType = exports.CompanyBankPaymentsSettingType || (exports.CompanyBankPaymentsSettingType = {}));
